export const layout = {
  pageWidth: `
    width: 90%;
    margin: 0 auto;
  `,
}
